export default {
  nav: {
    home: "ホーム",
    commitment: "CSR",
    development: "企業情報",
    quality: "品質保証",
    policy: "品質方針",
    target: "品質目標",
    authentication: "品質認証",
    category: "製品情報",
    housing: "エクステリア",
    daily: "リビング",
    kitchen: "キッチン",
    shower: "浴室",
    electric: "電装品用部品",
    construction: "建設機械内装品",
    technology: "技術情報",
    production: "自社開発",
    sensing: "設備情報",
    forming: "射出成形",
    sheet_metal_forming: "プレス加工",
    sheet_metal: "板金加工",
    welding: "溶接",
    packaging: "組立",
    mould: "金型",
    cooperative: "顧客情報",
    contact: "連絡"
  },
  contact: {
    title: "連絡方法",
    address_title: "所在地",
    address: "上海市松江工业区联阳路598号",
  },
  quick_link: {
    title: "クイックリンク",
  },
  banner: {
    "1_title": "ALL Round.",
    "1_con": "なんでもお任せ下さい。それが上海坂井の“自信”です。<br>金属、プラスチック、複合材料加工のプロ集団、上海坂井は長年の経験と徹底した品質管理で、お客様の多様なニーズにお応えします。",
    "2_title": "In Your Life",
    "2_con": "目立たないかもしれませんが、上海坂井の製品群は、あなたの身近で生活を支えています。<br>みなさまの安全で快適な暮らしのために、私たちは日々進化し続けます。"
  },
  commitment: {
    "main_title": "CSR",
    "main_con": "「人権尊重」と「グリーンマネージメント」を基本として従業員の作業環境を継続的に改善し、従業員の幸福な生活を確保します。経済、社会、環境に対して調和をとりながら持続的な発展に貢献します。",
    "1_title": "環境保護",
    "1_con": "省エネを進めて廃棄物を削減し、低炭素化と循環型経済を発展させ、水資源の再利用を進めます。絶えず最新の技術動向を見据え、技術革新を進めて効率化を高めていくことにより持続的な発展を実現し、社会に貢献するとともに、より多くの就業の機会を創造します。",
    "2_title": "作業の安全保障、リスク回避",
    "2_con": "従業員には安全な作業環境を提供して労働災害を引き起こさないようにします。各生産ラインに潜む業務上、危害を与えるような環境及び健康と安全を脅かすような事象に対してリスク評価を行い、従業員に対して定期的に安全教育を実施します。",
    "3_title": "誠実な経営と発展の実現",
    "3_con": "当社で生産する製品及びサービスはお客様の御要望通りか御要望に対して卓越しており、お客様の商業利益を保証して損害を与えることはありません。常に公平な取引を行い、賄賂等の汚職をすることはありません。お客様と共に発展していきたいと考えています。市場の秩序を自覚して法律に基づいた納税をしています。また社会と環境の基準を遵守します。当社では、この方針に基づき、各部門が密接に協力して会社情報の透明性と社会との合理性を高めていきます。",
    "4_title": "差別の廃止、職業能力の向上",
    "4_con": "労働者の差別、児童を雇用はしません。従業員が快適に仕事を行えるような作業環境にします。「女性労働者保護規定」を制定して実施しています。男女平等の就業、昇進を行い、性的な差別をしません。各組織の人員の育成教育を通じてスキルを向上させ、平等にキャリアアップの機会を与えるようにします。",
  },
  quality: {
    "policy_title": "品質方針",
    "policy_con": "お客様に信頼され、喜ばれる製品を作ろう。",
    "target_title": "品質目標",
    "target_con_1": "お客様中心主義、お客様の御要望達成",
    "target_con_2": "国際標準規格に基づいた品質管理、品質保証",
    "target_con_3": "新技術の取り込、新商品への挑戦",
    authentication_title: "品質認証",
    authentication_con: [{
        title: "1999",
        icon: ["t19001", "iaf", "cnas"],
        con: "方園認証機関標識<br>1999年10月質量管理体系資格ISO-9001取得"
      },
      {
        title: "2007",
        icon: ["ul", "ccc"],
        con: "2007年1月ＵＬ米國保険業者安全試験所認証資格取得<br>2007年4月中國（ＣＣＣ）強制認証取得"
      },
      {
        title: "2013",
        icon: ["t24001", "iaf", "cnas-2"],
        con: "方園認証機関標識<br>2013年5月環境管理体系資格ISO-14001取得"
      },
      {
        title: "2018",
        icon: ["t24001", "iaf-2", "cnas-3"],
        con: "2018年2015版質量/環境管理体系資格取得"
      }
    ],
    flow_title: "上海坂井の品質はお客さまの御要望を深く理解することから始まります。",
    flow_con: [{
        title: "お客様との打合せ",
        con: "初めにお客様の要望を完全に理解することが何より大切なことであると私達は考えます。上海坂井が大切にする「お客様と共に考える」が第一歩です。"
      },
      {
        title: "設計試作",
        con: "設計通りのスペックを発揮しているか、間違いは無いか、長年の経験が最適なカタチをつくりあげていきます。"
      },
      {
        title: "サンプル打合せ",
        con: "お客様と一緒に充分時間をかけて検討を加えます。各ステップに曖昧な点を残さない・・・、上海坂井のモノ作りが高い信頼を得る理由です。"
      },
      {
        title: "変更改善",
        con: "お客様のご意見をもとに改善を加えます。いよいよ量産に向けた最終工程です。妥協をしない上海坂井のクラフトマンシップが光ります。"
      },
      {
        title: "生産",
        con: "量産に向けたサンプルにGOが出て、いよいよ生産ラインが動き出します。厳しい品質管理が上海坂井の品質を支えます。"
      },
      {
        title: "検査",
        con: "人と目と手、そして効率を考えた検査冶具で最終のチェックを行います。不良品を作らない、そして不良品を決して納品しない、このことは上海坂井のモノ作りの基本です。"
      },
      {
        title: "納品",
        con: "上海坂井にとって、納品は終わりではなく次のステップアップの始まりです。さらにお客様からご意見を頂き、次の製品改良のノウハウを蓄積していきます。"
      }
    ]
  },
  sheet_metal_forming: {
    con: [
      "プレス加工は、弊社の4大ビジネスの中核を担い、上海にて20年近くの実績と経験があります。",
      "ご希望ロットに応じて順送、単発、タレパン加工を提案し、お客様のあらゆる御要望にもお応えできる自信があります。絞り加工品については概ね製品直径の2倍程度まで問題なく加工可能ですが、それ以上のご要望についても。日本語で丁寧に対応させていただきますので、何なりとお申し付けください。"
    ]
  },
  welding: {
    con: [
      "溶接加工は、弊社の4大ビジネスの中核を担い、上海にて20年近くの実績と経験があります。建材、自動車部品、日用品など非常に広範囲の製品を世の中に送り出して参りました。",
      "溶接加工には避けられない物の熱変形に関しても、自社設計の溶接治具を使用することによりお客様の御要望通りに仕上げることが可能です。溶接強度については、溶込み量、脚長、溶接条件管理および抜き取り破壊強度試験を通じて、100％の保証体制を構築しております。"
    ]
  },
  production: {
    con: [
      "自動化設備も自社開発することにより、コスト削減および品質向上が図れます。",
      "弊社は中国の不安定なビジネス環境を考慮し、極力内製化・自動化を行うことにより、お客様へ安定的に高品質製品をお届けし続けることが可能です。"
    ]
  },
  sensing: {
    table_title: {
      name: '机械名称',
      vender: "メーカー",
      num: "台数"
    },
    con: "長年の実績から培われた技術と、多種多様な設備で、 お客様の多様なニーズにお応えいたします。"
  },
  sheet_metal: {
    tips: "（ベンダー、整形、かしめ加工、研磨、鏡面処理、ヘアライン）",
    con: [
      "ベンダー加工は小ロット品の加工に適しており、金型製作の必要がありません。",
      "かしめ加工は溶接接合と比較して強度は劣りますが、クリーンで低コストな接合方法の一つです。製品の接合強度に応じてご提案が可能です。特にステンレスの表面加工は非常に豊かな経験を有しております。あらゆる種類の表面外観が実現可能です。"
    ]
  },
  forming: {
    con: [
      "射出成形は、弊社の4大ビジネス中核を担い、上海にて20年近くの実績と経験があります。",
      "成形機は100t~1300tまで揃えておりますので、お客様のあらゆる御要望にもお応えできる自信がございます。"
    ]
  },
  packaging: {
    con: [
      "組立事業は、弊社の4大ビジネスの集大成であり、「プレス+溶接+成形」を通じて製作した部品類を正確にアセンブリーすることにより製品の付加価値は一層高まります",
      "完成品またはサブアセンブリー状態まで組立加工し、中国国内トラック輸送およびコンテナによる輸出を行い、お客様のお手元にお届けいたします。(自社で輸出処理可能な貿易権を有しております。最終完成品までアセンブリーした製品は、日本語で印刷した取扱説明書を同梱し、ご指定先まで責任を持って出荷致します。"
    ]
  },
  mould: {
    con: [
      "自社内に金型加工部門を有することにより、新規案件開発のみならず量産開始後も迅速な対応が可能です。",
      "CAD・CAM技術を早くから取り入れ済み、高精度の加工が可能です。良い金型が良い製品を産み出します。"
    ]
  },
  cooperative: {
    "inland_title": "お客様（国内）",
    "foreign_title": "お客様（国外）",

    "inland_1": "骊住貿易（上海）有限公司 ",
    "inland_1_con": "カーポートブラケット、シャッターサイドカバー、ベランダ部品、壁付郵便ポスト、洗面架台、ドア用特殊ナット",
    "inland_2": "骊住建材（上海）有限公司",
    "inland_2_con": "カーポートブラケット、シャッターサイドカバー、ベランダ部品、壁付郵便ポスト、洗面架台、ドア用特殊ナット",
    "inland_3": "東陶（上海）有限公司",
    "inland_3_con": "ウォシュレット、浴室用三乾王、便座、便蓋",
    "inland_4": "東理化汽車電子（上海）有限公司",
    "inland_4_con": "ショベルカーキャビン内装品、操作レバー",
    "inland_5": "上海日立家用電器有限公司",
    "inland_5_con": "洗濯機プラスチック部品、モーター軸受け部品",
    "inland_6": "南京日立産機有限公司",
    "inland_6_con": " コントロールボックス",
    "inland_7": "松下住宅电器（上海）有限公司",
    "inland_7_con": "マッサージチェア部品、布張り部品、ライト部品",
    "inland_8": "村田汽車塑料零部件(上海)有限公司		",
    "inland_8_con": "バッテリーケース",
    "inland_9": "上海小里機材有限公司",
    "inland_9_con": "送風機接続部品",
    "inland_10": "三菱電機自動化機器製造(常熟)有限公司",
    "inland_10_con": "電装品用部品",
    "inland_11": "深圳市裕興実業有限公司",
    "inland_11_con": "厨房用部品",
    "inland_12": "伊予金属製品(上海)有限公司",
    "inland_12_con": "楽器部品",
    "inland_13": "蕯那電子(上海)有限公司",
    "inland_13_con": "蛍光灯部品",

    "foreign_1": "富士工業（株）",
    "foreign_1_con": "レンジフード",
    "foreign_2": "TOTOアクアテクノ（株）",
    "foreign_2_con": "溶室用・洗面所用三乾王",
    "foreign_3": "TOTOバスクリエイト(株)",
    "foreign_3_con": "バスエプロン",
    "foreign_4": "(株)东海理化クリエイト",
    "foreign_4_con": "ショベルカーキャビン内装品、操作レバー",
    "foreign_5": "パナソニック　エイジフリー(株)",
    "foreign_5_con": "介護用バススツール、バスボード、移乗台",
    "foreign_6": "日立グローバルライフソリューションズ(株)",
    "foreign_6_con": "洗濯機乾燥機用スタンド",
    "foreign_7": "(株)ハウステック",
    "foreign_7_con": "厨房・衛生機器部品",
    "foreign_8": "クリナップ(株)",
    "foreign_8_con": "システムキッチン引出し部品",
    "foreign_9": "シャ-プ(株)",
    "foreign_9_con": "洗濯機乾燥機用スタンド",
    "foreign_10": "(株)トヨウラ",
    "foreign_10_con": "厨房用ステンレス部品",
    // "foreign_11": "(株)电技商会",
    // "foreign_11_con": "ハーネス",
    "foreign_11": "(株)カクダイ",
    "foreign_11_con": "洗濯機パン",
  },
  development: {
    main_title: "半世紀の歴史。世界に広がる坂井グループ",
    outline_title: "上海坂井概要",
    history_title: "グループ沿革"
  },
  development_outline: [{
      title: "社名",
      con: "上海坂井塑料成形有限公司"
    },
    {
      title: "所在地",
      con: "上海市松江工业区联阳路598号"
    },
    {
      title: "TEL",
      con: "+86 21 57741131"
    },
    {
      title: "FAX",
      con: "+86 21 57740636"
    },
    {
      title: "資本金",
      con: "1,127.8万 USD"
    },
    {
      title: "投資総額",
      con: "1,427.8万 USD"
    },
    {
      title: "資本内容",
      con: "独資企業<br>泉商事株式会社　15.3％<br>株式会社トヨウラ　70.05％<br>富士工業株式会社　13.65％"
    },
    {
      title: "敷地面積",
      con: "15,748m2"
    },
    {
      title: "従業員",
      con: "200名"
    },
    {
      title: "設立",
      con: "会社設立　1996年3月19日<br>工場稼動　1996年11月15日"
    },
    {
      title: "経営内容",
      con: "【加工技術】<br>プラスチック成形加工、金属プレス、板金加工、溶接加工、パイプ加工（切断、曲げ、研磨、羽布、溶接）、部品・製品組立、並びに金型製品（金属プレス金型、射出成形金型）の製造・販売<br>【商品】<br>介護用品・生活用品・台所用品・住宅建材用品・電気用品などの住宅商品、建設機械の内装品、産業機械の部品、自動車の内装品などの製造・販売"
    }
  ],
  development_history: [{
      title: "1956",
      con: "泉製作所(現泉商事第一工場)開設<br>鉄材による製品製造開始"
    },
    {
      title: "1967",
      con: "(株)那珂製作所(現泉商事第二工場)開設<br>プラスチック分野に進出"
    },
    {
      title: "1971",
      con: "(株)トヨウラ設立<br>ステンレス材を主体としたキッチン、浴槽等関連分野に進出"
    },
    {
      title: "1973",
      con: "泉商事(株）設立<br>事業の発展に合わせて仕入れ、販売を効率化"
    },
    {
      title: "1996",
      con: "上海坂井塑料成形有限公司設立<br>家電、住宅設備、自動車、OA機器他の部品、完成品の製造開始"
    },
    {
      title: "2001",
      con: "上海坂井国際貿易有限公司設立<br>材料輸入、完成品輸出を効率化"
    },
    {
      title: "2005",
      con: "泉商事(株)と(株)泉製作所（第一工場・第二工場)を合弁製販の効率化と顧客ニーズへの対応をスピードアップ"
    },
    {
      title: "2007",
      con: "(株)トヨウラ大阪営業事務所開設"
    },
    {
      title: "2012",
      con: "(株)トヨウラ東京渋谷ショールーム開設"
    },
    {
      title: "2014",
      con: "本社移転(東京都渋谷区）"
    },
    {
      title: "2016",
      con: "(株)トヨウラ福岡営業事務所開設"
    }
  ],
  sensing_plastic: {
    title: "プラスチック加工関係",

    con: [{
        name: "1300T射出成形機",
        vender: "三菱重工",
        num: "1"
      }, {
        name: "850T射出成形機",
        vender: "三菱重工",
        num: "2"
      }, {
        name: "650T射出成形機      ",
        vender: "三菱重工",
        num: "1"
      }, {
        name: "650T電動射出成形機      ",
        vender: "海天",
        num: "1"
      },
      {
        name: "550T電動射出成形機      ",
        vender: "海天",
        num: "1"
      },
      {
        name: "550T射出成形機      ",
        vender: "三菱重工",
        num: "1"
      }, {
        name: "350T射出成形機      ",
        vender: "三菱重工",
        num: "2"
      }, {
        name: "230T電動射出成形機      ",
        vender: "海天",
        num: "3"
      }, {
        name: "120T電動射出成形機      ",
        vender: "海天",
        num: "2"
      }, {
        name: "ホットスタンプ機",
        vender: "日本製",
        num: "2"
      }, {
        name: "シルク印刷機",
        vender: "中国製",
        num: "2"
      }, {
        name: "タンブラー(200kg)",
        vender: "中国製",
        num: "1"
      }, {
        name: "自動シルク印刷機",
        vender: "中国製",
        num: "1"
      }, {
        name: "タンポ印刷機(P1単色）",
        vender: "上海網諠",
        num: "1"
      }
    ]
  },
  sensing_metal: {
    title: "金属加工関係",
    con: [{
      name: "500T順送プレス機",
      vender: "金豊",
      num: "1"
    }, {
      name: "200T順送プレス機",
      vender: "AIDA",
      num: "1"
    }, {
      name: "150Tプレス機",
      vender: "AIDA",
      num: "13"
    }, {
      name: "110Tプレス機",
      vender: "AIDA",
      num: "1"
    }, {
      name: "60Tプレス機",
      vender: "中国製",
      num: "2"
    }, {
      name: "45Tプレス機",
      vender: "金豊",
      num: "2"
    }, {
      name: "タレットパンチプレス機",
      vender: "AMADA",
      num: "1"
    }, {
      name: "100Tベンダー",
      vender: "AMADA",
      num: "2"
    }, {
      name: "NC切削機",
      vender: "OKUMA",
      num: "3"
    }, {
      name: "自動パイプ曲げ機",
      vender: "OPTON（日本製）",
      num: "1"
    }, {
      name: "パイプカット機",
      vender: "中国製",
      num: "1"
    }, {
      name: "パイプバフ機",
      vender: "中国製",
      num: "2"
    }, {
      name: "スポット溶接機",
      vender: "パナソニック",
      num: "4"
    }, {
      name: "アルゴン溶接機",
      vender: "パナソニック",
      num: "4"
    }, {
      name: "CO2溶接機",
      vender: "パナソニック",
      num: "2"
    }, {
      name: "自動溶接ロボット",
      vender: "パナソニック(自社製）",
      num: "5"
    }, {
      name: "半自動タッピングマシン",
      vender: "中国製",
      num: "12"
    }, {
      name: "50曲げ機",
      vender: "米路加",
      num: "1"
    }, {
      name: "インサート半自動機",
      vender: "自社製",
      num: "1"
    }, {
      name: "フィルター切断機",
      vender: "自社製",
      num: "1"
    }, {
      name: "フィルター熱風整形機",
      vender: "自社製",
      num: "1"
    }, {
      name: "自動組立機",
      vender: "自社製",
      num: "1"
    }, {
      name: "エアリーク試験機",
      vender: "自社製",
      num: "1"
    }, {
      name: "サイドカバー多軸タップ機",
      vender: "自社製",
      num: "1"
    }, {
      name: "ゲート自動カット機",
      vender: "自社製",
      num: "1"
    }]
  },
  more: "Learn More",
  housing: [
    "カーポートブラケット",
    "家庭用シャッター取付枠",
    "郵便箱",
    "天窓防水部品",
    "ベランダ部品",
    "ベランダ部品"
  ],
  kitchen: [
    "レンジフード（アメリカ）",
    "フィルター",
    "シロッコファン",
    "スリムライト",
    "レンジフード（シンガボール）",
    "ステンレスシンク",
    "システムキッチン網かご"
  ],
  daily: [
    "マッサージチェア脚部",
    "マッサージチェア脚部",
    "背上げ式自動ベッド",
    "シャワーチェア",
  ],
  shower: [
    "便蓋・便座",
    "温風乾燥機部品",
    "浴室介護用バスボート",
    "浴室介護用椅子",
    "座式シャワー",
    "浴室乾燥機パーツ",
    "浴室乾燥機パーツ",
    "洋式安全手摺り",
    "洗面架台",
    "洗剤ラック",
    "洗剤ラック",
    "化粧台サイドボード",
    "移乗台"
  ],
  electric: [
    "インバーターケース",
    "電力計ケース",
    "サーボアンプカバー"
  ],
  construction: [
    "ショベルカー内装用パーツ",
    "ショベルカー内装用パーツ",
    "乗用車用サンバイザー",
    "乗用車用サンバイザー"
  ]
}